/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import "../../CSS/general.css";
import Axios from "axios";
import ActionButtons from "./ActionButton";
import { API_ROUTE, Routes } from "../../Helpers/Constants"
import AuthenticationContext from "../../Store/Authentication-Context";
import { AgGridReact } from 'ag-grid-react';
import LoaderGif from "../../images/365 loading.gif";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AgreementDropDown from "./AgreementDropDown";
import AdditionDropDown from "./AdditionDropDown";
const Step4 = (props) => {
    const { setAuthContext} = useContext(AuthenticationContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [filter, setFilter] = useState({});
    const [additionLines, setAdditionLines] = useState();
    const refFilter = useRef(null);
   
    const validate = () => {
        
         props.closePopupModal();
     
    };
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const additionOptionsRef = useRef([]);


    function closeModal(params) {
        setIsModalOpen(params);
    }
    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }
    useEffect(() => {
        if (gridApi && filter) {
         
            gridApi.setFilterModel(filter);
            gridApi.onFilterChanged(); 
           // gridApi.refreshClientSideRowModel('filter');
        }
    }, [gridApi, filter]);
    const renderTooltip = (props) => {
  
        return (
            <pre>
            <Tooltip id={`tooltip-${props.id}`} {...props}>
                {props.text}
                </Tooltip>
                </pre>
        );

    }
    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
     //  flex: 1
    }), []);
    const flagChangeQtyRenderer = (params) => {
        const prevQty = parseFloat(params.data.prevQty) || 0;
        const qty = parseFloat(params.data.qty) || 0;

        if (prevQty !== 0 && prevQty !== qty) 
        {
            return <span style={{ color: 'red' }} title='Difference in quantity' > {params.data.prevQty}</ span>;
        }
        else {
            return params.data.prevQty
        }
    };

    const flagChangePriceRenderer = (params) => {
        const prevPrice = parseFloat(params.data.prevPrice) || 0;
        const price = parseFloat(params.data.price) || 0;
        if (prevPrice !== 0 && prevPrice !== price) {
            return <span style={{ color: 'red' }} title='Difference in price' > {params.data.prevPrice}</ span>;
        }
        else {
            return params.data.prevPrice
        }
    };
    const handleAgreementChanged = async (params) => {

      

        // Make the API call to update the setting on the server
        try {
            setFilter(gridApi.getFilterModel());
            refFilter.current = gridApi.getFilterModel();
            const tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ${tokenString}`,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            await Axios.patch(API_ROUTE + Routes.SET_CW_AGREEMENTID + '/' + params.data.orgId + '/' + params.newValue, "", config)
                .then((response) => {
                    setAdditionLines(prevLines =>
                        prevLines.map(line =>
                            line.orgId === params.data.orgId ? { ...line, cwAgreementID: params.newValue } : line
                        )
                    );
                })
                .catch((reason) => {
                    console.error("Error updating AgreementID:", reason);
                });

            setTimeout(() => {
                if (gridApi && refFilter.current) {
                    gridApi.onFilterChanged();
                    gridApi.refreshClientSideRowModel('filter');
                }
            }, 0);
        } catch (error) {
            console.error("Error in handleAgreementChanged:", error);
        }



    };

    const handleAdditionChanged = async (params) => {

      
        let apiRoute = params.data.isDiskPackage ? Routes.SET_CW_DISC_ADDNO : Routes.SET_CW_PACKAGE_ADDNO;
        // Make the API call to update the setting on the server
        try {
            setFilter(gridApi.getFilterModel());
            refFilter.current = gridApi.getFilterModel();
            const tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ${tokenString}`,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            await Axios.patch(API_ROUTE + apiRoute + '/' + params.data.orgId + '/' + params.newValue,"", config)
                .then((response) => {
                    setAdditionLines(prevLines =>
                        prevLines.map(line =>
                            line.invoiceLineNo === params.data.invoiceLineNo ? { ...line, cwAddNo: params.newValue } : line
                        )
                    );
                })
                .catch((reason) => {
                    console.error("Error updating Addition Id:", reason);
                });
            setTimeout(() => {
                if (gridApi ) {
                    gridApi.onFilterChanged();
                    gridApi.refreshClientSideRowModel('filter');
                }
            }, 0);
        } catch (error) {
            console.error("Error in handleAdditionChanged:", error);
        }



    };
    const saveColumnState = () => {
        if (gridColumnApi) {
            return gridColumnApi.getColumnState();
        }
        return null;
    };
    const restoreColumnState = (columnApi) => {
        if (gridColumnApi && columnApi) {
            gridColumnApi.setColumnState(columnApi); 
        }
    };
    const columnDefs = [
        { field: 'resellerName', sortable: true, headerName: 'Reseller Name', filter: true, minWidth: 150 },
        { field: 'orgName', sortable: true, headerName: 'Organisation Name', filter: true, minWidth: 150 },  
        {
            field: 'cwAgreementID', sortable: true, headerName: 'Agreement ID', filter: true, minWidth: 125, editable: true, cellEditorFramework: AgreementDropDown, cellEditorParams: (params) => {
              
            const filteredAgreements = props.agreements && props.agreements.filter(agreement => agreement.company.id === params.data.resellerCWCompanyID);
            return {
                values: filteredAgreements
            };
            }, onCellValueChanged: handleAgreementChanged, flex: 1
        }, {
            headerName: "",
            cellRenderer: (params) => (
                <button className="a-icon"
                    onClick={() =>
                        params.api.startEditingCell({
                            rowIndex: params.node.rowIndex,
                            colKey: "cwAgreementID",
                        })
                    }
                >
                    <OverlayTrigger
                        key="sort-1"
                        placement="top"
                        delay={{ show: 50, hide: 50 }}
                        overlay={(overenderTooltiprlayProps) =>
                            renderTooltip({
                                ...overenderTooltiprlayProps,
                                id: "sort-1",
                                text: "Edit Aggreement",
                            })
                        }
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                        >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                        </svg>
                    </OverlayTrigger>
                </button>

            ),
            flex: 1,
            sortable: false,
            maxWidth: 25,
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }
        },
        {
            field: 'cwAddNo', sortable: true, headerName: 'Addition ID', filter: true, editable: true, minWidth: 50, cellEditorFramework: AdditionDropDown,
            cellEditorParams: (params) => {
                return { values: additionOptionsRef.current }; 
            },
           
            onCellValueChanged: handleAdditionChanged,
        }, {
            headerName: "",
            cellRenderer: (params) => (
                <button className="a-icon"
                    onClick={async (e) => { // Make this an async function
                       
                        var tokenString = await setAuthContext("", new Date());

                        const config = {
                            headers: {
                                Authorisation: `Bearer ` + tokenString,
                                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                            },
                        };

                        try {
                            const response = await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_ADDITION_FOR_AGREEMENT + '/' + params.data.cwAgreementID, config);
                            if (response && response.data) {
                                additionOptionsRef.current = response.data
                                params.api.startEditingCell({
                                    rowIndex: params.node.rowIndex,
                                    colKey: "cwAddNo",
                                });
                            }
                        } catch (reason) {
                            if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        }
                               
                            
                       
                    }}
                >
                    <OverlayTrigger
                        key="sort-1"
                        placement="top"
                        delay={{ show: 50, hide: 50 }}
                        overlay={(overenderTooltiprlayProps) =>
                            renderTooltip({
                                ...overenderTooltiprlayProps,
                                id: "sort-1",
                                text: "Edit Addition",
                            })
                        }
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                        >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                        </svg>
                    </OverlayTrigger>
                </button>

            ),
            flex: 1,
            sortable: false,
            maxWidth: 25,
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }
        },
        { field: 'invoiceDescription', sortable: true, filter: true, headerName: 'Invoice Description', minWidth: 150 },
        {
            field: 'prevQty', sortable: true, headerName: 'Prev Qty', filter: true, minWidth: 75, flex: 1, cellRenderer: (params) => {
                return flagChangeQtyRenderer(params)
            }, },
        { field: 'qty', sortable: true, headerName: 'Qty', filter: true, minWidth: 75, flex: 1 },
        {
            field: 'prevPrice', sortable: true, headerName: 'Prev Price', filter: true, minWidth: 50, flex: 1, cellRenderer: (params) => {
            return flagChangePriceRenderer(params)
        }, },
        { field: 'price', sortable: true, filter: true, headerName: 'Price', minWidth: 100, flex: 1, },
        { field: 'managementType', sortable: true, filter: true, headerName: 'Management Type', minWidth: 170, flex: 1, },
        { field: 'status', sortable: true, filter: true, headerName: 'Status', minWidth: 100, flex: 1, },
        
        {
            headerName: '', maxWidth: 50, flex: 1, 
            cellRenderer: (params) => {
                const handleClick = () => {
                    const errorMessage = params.data.errorMessage || 'No error message';
                    setModalMessage(errorMessage);
                
                    setIsModalOpen(true);
                };
                const ignoreAddition = async () => {
                    let columnApi = saveColumnState();
                    setFilter(gridApi.getFilterModel());
                   
                    refFilter.current = gridApi.getFilterModel();
                    var tokenString = await setAuthContext("", new Date());
                    const updatedData = {
                        ...params.data,
                        status: "IGNORE"
                    };
                    const config = {
                        headers: {
                            Authorisation: `Bearer ` + tokenString,
                            CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                        },
                    };

                    try {
                        const response = await Axios.put(API_ROUTE + Routes.UPDATE_CONNECTWISE_ADDITION, updatedData, config);
                        if (response) {
                            
                          
                            setAdditionLines(prevLines =>
                                prevLines.map(line =>
                                    line.invoiceLineNo === params.data.invoiceLineNo ? { ...line, status: "IGNORE" } : line
                                )
                            );
                        }
                        setTimeout(() => {
                            if (gridApi && refFilter.current) {
                                gridApi.onFilterChanged();
                                gridApi.refreshClientSideRowModel('filter');
                            }
                            restoreColumnState(columnApi);
                        }, 0);

                    } catch (reason) {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    }
                };
                return (
                    <>
                        {params.data.errorMessage &&
                            <div className="justify-content-between d-flex align-items-center">
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "Error-1", text: params.data.errorMessage })}>
                                    <button className="a-icon" title={params.data.errorMessage} onClick={() => handleClick(params)}>
                                   
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                    </svg>
                                   
                                    </button>
                                </OverlayTrigger>
                                <button className="a-icon" title={"Ignore the addition"} onClick={() => ignoreAddition(params)}>

                                    <svg class="svg-icon" width="16" height="16" fill="currentColor" viewBox="0 0 1024 1024" version="1.1"><path d="M511.675127 0C229.086213 0 0 229.084914 0 511.675127 0 794.26664 229.086213 1023.350254 511.675127 1023.350254S1023.350254 794.26534 1023.350254 511.675127C1023.350254 229.087513 794.264041 0 511.675127 0z m0 921.015228c-226.07269 0-409.338802-183.267411-409.338802-409.340101s183.267411-409.340102 409.338802-409.340102c226.07399 0 409.340102 183.267411 409.340101 409.340102s-183.267411 409.340102-409.340101 409.340101zM292.385787 438.57868h438.57868V584.771574H292.385787V438.57868z" fill="#000000" /></svg>

                                </button>
                            </div>

                        }
                    </>

                );
            }
        },       

    ];
    
    async function getAddditionLine() {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        await Axios.get(API_ROUTE + Routes.GET_ADDITION_LINES, config)
            .then((response) => {

                if (response && response.data) {
                    let responsedata = response.data;

                    processAdditionLines(responsedata);
                    
                }

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }

            });
    }
    async function processAdditionLines(additionLines) {
        
        
        const tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ${tokenString}`,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        try {

            await Axios.post(API_ROUTE + Routes.PROCESS_CONNECTWISE_ADDITIONLINES, additionLines, config)
                .then((response) => {
           
                    if (response && response.data) {
                        setAdditionLines(response.data);
                        setDisabled(false);
                    }


                })
                .catch((error) => {
                    console.error("Error processAdditionLines:", error);
                    if (error?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

        } catch (error) {
            console.error("Error in processAdditionLines:", error);
        }


    }

    useEffect(() => {
        getAddditionLine();
    }, [props.agreements]);


    

    return (

        <div id="step4">
            <div id="UpdatePanel1">
                <div className="card">
                    <h4 className="card-header ">
                        <span id="TitleLabel" className="SectionTitle">Update Additions &nbsp;</span>
                      
                    </h4>
                    <div className="card-body" style={{ borderStyle: "None", height: "400px", width: "100%" }}>
                        
                            <div style={{ width: "99%", display: 'flex', justifyContent: 'flex-end' }}>
                            <button id="ContentPlaceHolder1_btnClear" style={{ color: "#007bff", cursor: 'pointer', float: 'inline-end' }} className="me-1 a-icon">
                                    <Button title="Clear Filter" onClick={(e) => {
                                        if (gridApi) {
                                            gridApi.setFilterModel(null);
                                            setFilter(null);
                                            refFilter.current = null;
                                        }
                                    }
                                    } variant="primary" style={{ padding: '5px 7px' }} >
                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" fill="white" stroke="white" viewBox="0 0 32 32" width="20" style={{ cursor: 'pointer' }}>
                                            <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                            <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                                        </svg>
                                    </Button>
                            </button>
                            <button id="ContentPlaceHolder1_btnDownload" style={{ color: "#007bff", cursor: 'pointer', top: '2.5rem', float: 'inline-end' }} className="me-2 a-icon">
                                <Button title="Download" onClick={(e) => {
                                    if (gridApi) {
                                        gridApi.exportDataAsCsv();
                                        // gridApiRefs.operations.current.sizeColumnsToFit();
                                    }
                                    
                                }
                                } variant="primary">   <svg
                                        className="svg-inline--fa fa-download fa-w-18 fa-lg"
                                        style={{ color: 'white', fill: 'transparent', fontSize: '16px' }}
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="download"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z"
                                        />
                                    </svg></Button>

                            </button>

                            </div>
                        <div className="ag-theme-alpine ms-2" style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "99%", height: '100%', overflowY: "auto" }}>
                        
                            <AgGridReact
                                columnDefs={columnDefs}
                                rowData={additionLines}
                                onGridReady={onGridReady}
                               
                                defaultColDef={defaultColDef}
                                singleClickEdit={true}  
                                stopEditingWhenCellsLoseFocus={true} 
                                domLayout="normal"
                                overlayLoadingTemplate={
                                    `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                            />
                        </div>
                    </div>
                    <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', marginTop: '5px' }}>
                        &nbsp;
                    </div>
                                   <div style={{
                        display: 'flex', justifyContent: 'flex-end', padding: '10px'
}}>

                        <ActionButtons {...props} isDisabled={disabled} lastStep={validate} />

                    </div>
                </div>
                <input type="hidden" name="btnhelp" id="btnhelp" />
                <Modal
                    show={isModalOpen}
                    onHide={closeModal} backdrop="static"
                    size="xl"
                >  <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header><Modal.Body>
                        <>
                            {modalMessage}
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModal}>
                            Close
                        </Button>
                    </Modal.Footer>

                </Modal>
            </div>
           
           
        </div>
    );
}
export default Step4;